import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import { PieChart, Pie, Sector } from 'recharts';
import { FaRupeeSign } from 'react-icons/fa';
import { Home, Clock } from 'lucide-react';
import { Package } from 'lucide-react';
import { BaseUrl } from '../App';
import { FaGlobe, FaUsers, FaChartLine, FaArrowDown, FaRegHandshake, FaTimesCircle } from 'react-icons/fa';
import { generateRandomColor } from 'make-random-color';
import axios from 'axios';
import { FadeLoader } from 'react-spinners';


const CleaningStaffDashboard = () => {
  // Animation states
  const [isLoaded, setIsLoaded] = useState(false);
  const [Totalbookingcount, setTotalbookingcount] = useState(null);
  const [TotalBookingComplete, setTotalBookingComplete] = useState(null);
  const [TotalBookingConfirm, setTotalBookingConfirm] = useState(null);
  const [TotalBookingCancelByProvider, setTotalBookingCancelByProvider] = useState(null);
  const [TotalBookingReject, setTotalBookingReject] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [serviceCount, setServiceCount] = useState(null);
  const [payment, setpayment] = useState(null);
  const [Customer, setCustomer] = useState([]);
  const [TotalOrderCount, setTotalOrderCount] = useState([]);
  const [TotalProfit, setTotalProfit] = useState([]);
  const [todayBookingCount, setTodayBookingCount] = useState(null);
  const [staffId, setStaffId] = useState(null);
  const [UpcomingBookingCount, setUpcomingBookingCount] = useState(null);
  const [AllTodayBooking , setAllTodayBooking] = useState(null);
  const [PastBookingCount, setPastBookingCount] = useState(null);
  const [serviceTypeData, setServiceTypeData] = useState([]);
  const [TotalBookingCompleteStaff,  setTotalBookingCompleteStaff] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setIsLoaded(true);
  }, []);
  const generateRandomColor = () => {
    return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
  };
  // const serviceTypeData = [
  //   { name: 'Standard Clean', value: 45.8, color: '#1E88E5' },
  //   { name: 'Deep Clean', value: 28.2, color: '#FFC107' },
  //   { name: 'Move-in/out', value: 16.5, color: '#6A1B9A' },
  //   { name: 'Office Clean', value: 9.5, color: '#FF7043' },
  // ];

  const monthlyBookings = [
    { month: 'Jan', residentialBookings: 40, commercialBookings: 25 },
    { month: 'Feb', residentialBookings: 35, commercialBookings: 28 },
    { month: 'Mar', residentialBookings: 42, commercialBookings: 30 },
    { month: 'Apr', residentialBookings: 38, commercialBookings: 35 },
    { month: 'May', residentialBookings: 45, commercialBookings: 40 },
    { month: 'Jun', residentialBookings: 50, commercialBookings: 38 },
    { month: 'Jul', residentialBookings: 55, commercialBookings: 42 },
    { month: 'Aug', residentialBookings: 60, commercialBookings: 45 },
    { month: 'Sep', residentialBookings: 52, commercialBookings: 40 },
  ];
  
  // Custom rendered activePieShape
  const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent } = props;
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill} className="text-sm font-medium">
          {`${payload.name}`}
        </text>
        <text x={cx} y={cy + 20} textAnchor="middle" fill={fill} className="text-xs">
          {`${(percent * 100).toFixed(1)}%`}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 5}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };
  
  const StatCard = ({ icon, value, label, id, color }) => {
    const isHovered = hoveredCard === id;
  
    return (
      <div
        className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 
        ${isHovered ? 'transform scale-105 shadow-lg' : ''} 
        hover:bg-blue-50 animate-fadeIn border border-gray-200 flex items-center`}
        onMouseEnter={() => setHoveredCard(id)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        {/* Icon Container */}
        <div className={`p-2 ${color} text-white rounded-full transition-transform duration-300 ${isHovered ? 'scale-110' : ''}`}>
          {icon}
        </div>
  
        {/* Content Container */}
        <div className="ml-3 flex flex-1 items-center justify-between w-full">
          {/* Label and Number Inline */}
          <div className="text-gray-500 text-xs uppercase">{label}</div>
          <div className="text-2xl font-bold text-blue-600">{value}</div>
        </div>
      </div>
    );
  };
  
  
  const LargeMetricCard = ({ title, value, icon, className }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`p-6 rounded-lg shadow-sm flex items-center justify-between transition-transform duration-300 ${className} ${
          isHovered ? 'transform scale-102 shadow-md' : ''
        } animate-slideInRight border border-gray-200`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div>
          <div className="text-sm mb-1">{title}</div>
          <div className="text-2xl font-bold animate-countUp">{value}</div>
        </div>
        <div className={`p-3 rounded-full transition-transform duration-300 ${
          isHovered ? 'scale-110' : ''
        }`}>
          {icon}
        </div>
      </div>
    );
  };
  
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  const cardShadowClass = "shadow-lg";
  // Fetch data on component load
  useEffect(() => {
    // setIsLoaded(true);
    setLoading(true);
    
    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem('userId');
    if (staffIdFromLocalStorage) {
      setStaffId(staffIdFromLocalStorage);
    }
    
    // Get current date for API call
    const currentDate = new Date().toISOString().slice(0, 19).replace('T', ' ');
    
    // Fetch upcoming bookings if staffId is available
    if (staffIdFromLocalStorage) {
      const fetchTotalBookingStaff = async () => {
        try {
          const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
            action: 'upcoming_bookings',
            staff_ids: staffIdFromLocalStorage,
            booking_date: currentDate
          });
          
          setUpcomingBookingCount(response.data.upcoming_booking_count);
        } catch (error) {
          console.error('Error fetching upcoming bookings:', error);
        }  finally {
          setLoading(false);
        }
    
      };
      
      fetchTotalBookingStaff();
    }
  }, []);


  useEffect(() => {
    // setIsLoaded(true);
    setLoading(true); 
    
    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem('userId');
    if (staffIdFromLocalStorage) {
      setStaffId(staffIdFromLocalStorage);
    }
  
    // Fetch upcoming bookings if staffId is available
    if (staffIdFromLocalStorage) {
      const fetchUpcomingBookings = async () => {
        try {
          const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
            action: 'completeBookingStaff',
            staff_ids: staffIdFromLocalStorage,
          });
          
          setTotalBookingCompleteStaff(response.data.completed_bookings);
        } catch (error) {
          console.error('Error fetching upcoming bookings:', error);
        }  finally {
          setLoading(false);
        }
    
      };
      
      fetchUpcomingBookings();
    }
  }, []);
  
  useEffect(() => {
    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem('userId');
    
    // Get current date for API call
    const currentDate = new Date().toISOString().slice(0, 19).replace('T', ' ');
    
    // Fetch today's booking count if staffId is available
    if (staffIdFromLocalStorage) {
      const fetchTodayBookings = async () => {
        setLoading(true);
        try {
          const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
            action: 'today_bookings',
            staff_ids: staffIdFromLocalStorage,
            booking_date: currentDate
          });
          
          setTodayBookingCount(response.data.today_booking_count);
        } catch (error) {
          console.error('Error fetching today bookings:', error);
        }  finally {
          setLoading(false);
        }
    
      };
      
      fetchTodayBookings();
    }
  }, []);
  
  useEffect(() => {
    // Retrieve staff_id from localStorage
    const staffIdFromLocalStorage = sessionStorage.getItem('userId');
    
    // Fetch past bookings if staffId is available
    if (staffIdFromLocalStorage) {
      const fetchPastBookings = async () => {
        setLoading(true);

        try {
          const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
            action: 'past_bookings',
            staff_ids: staffIdFromLocalStorage,
          });
          
          setPastBookingCount(response.data.past_booking_count);
        } catch (error) {
          console.error('Error fetching past bookings:', error);
        }  finally {
          setLoading(false);
        }
    
      };
      
      fetchPastBookings();
    }
  }, []);
    
  useEffect(() => {
    const staffIdFromLocalStorage = sessionStorage.getItem('userId'); // Retrieve staff_id from localStorage
  
    if (staffIdFromLocalStorage) {
      const fetchAllTodayBookingUSer = async () => {
        setLoading(true);

        try {
          const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, {
            action: "bookingDetails",
            staff_id: staffIdFromLocalStorage,
          });
  
          if (response.data.status === true) { // Check if status is true
            console.log(response.data.bookings); // Log bookings to verify data
            setAllTodayBooking(response.data.bookings); // Set bookings data in state
          } else {
            console.error('No bookings found.');
            setAllTodayBooking([]); // Set an empty array if no bookings
          }
        } catch (error) {
          console.error('Error fetching today bookings:', error);
        }  finally {
          setLoading(false);
        }
    
      };
  
      fetchAllTodayBookingUSer();
    }
  }, []);
  
  useEffect(() => {
    const fetchTotalOrder = async () => {
      setLoading(true);

      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: 'totalorder' }
        );
        console.log(response.data)
        setTotalOrderCount(response.data.total_bookings);
      } catch (error) {
        console.error('Error fetching total staff:', error);
      }  finally {
        setLoading(false);
      }
  
    };

    fetchTotalOrder();
  }, []);
  
  useEffect(() => {
    const fetchServiceData = async () => {
      setLoading(true);

      try {
        const response = await axios.post(`${BaseUrl}/backend/api/dashboard.php`, { action: 'AllserviceCount' });
        const transformedData = response.data.services.map(service => ({
          name: service.title,
          value: parseInt(service.service_count),
          color: generateRandomColor()
        }));
        setServiceTypeData(transformedData.filter(service => service.value > 0));
      } catch (error) {
        console.error('Error fetching service data:', error);
      }  finally {
        setLoading(false);
      }
  
    };

    fetchServiceData();
  }, []);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: 'customer' }
        );
        setCustomer(response.data.total_user_count);
      } catch (error) {
        console.error('Error fetching Customer count:', error);
      }  finally {
        setLoading(false);
      }
  
    };
  
    fetchCustomer();
  }, []);
  
  
  return (

    
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div
      className={`p-4 sm:p-6 bg-gray-50 min-h-screen transition-opacity duration-700 overflow-x-hidden rounded-xl shadow-lg ${
        isLoaded ? "opacity-100" : "opacity-0"
      } w-full sm:max-w-[90%] md:max-w-[80%] lg:max-w-full`}
    >
      {/* Grid layout for mobile and desktop */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5 mb-4">
        <StatCard
          id="customers"
          icon={<FaUsers size={20} />}
          value={Customer}
          label="Total Customer"
          color="bg-blue-800"
        />
        <StatCard
          id="revenue"
          icon={<FaGlobe size={20} />}
          value={TotalOrderCount}
          label="Total Bookings"
          color="bg-blue-800"
        />
        <StatCard
          id="growth"
          icon={<FaChartLine size={20} />}
          value={TotalBookingCompleteStaff}
          label="Total Booking Complete Staff"
          color="bg-blue-800"
        />
        <StatCard
          id="returns"
          icon={<FaArrowDown size={20} />}
          value={TotalBookingCancelByProvider}
          label="Booking Cancel"
          color="bg-blue-800"
        />
      </div>

      {/* Improved metric cards layout */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-4">
        <LargeMetricCard
          title="Today Booking"
          value={todayBookingCount || (<span className="text-xl">Sorry Today Booking Not Available</span>)}
          icon={<Package size={24} className="text-white" />}
          className="bg-blue-800 text-white"
        />
        <LargeMetricCard
          title="Future Booking"
          value={UpcomingBookingCount ||(<span className="text-xl">Sorry Future Booking Not Available </span>)}
          icon={<FaRupeeSign size={24} className="text-blue-800" />}
          className="bg-white text-gray-800"
        />
        <LargeMetricCard
          title="Past Booking"
          value={PastBookingCount ||( <span className="text-xl">Sorry Past Booking Not Available</span>)}
          icon={<Package size={24} className="text-white" />}
          className="bg-white-600 text-gray-800"
        />
      </div>

      {/* Charts Section - Responsive Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6">
        {/* Service Type Distribution Chart */}
        <div
          className={`bg-white rounded-lg ${cardShadowClass} p-4 transform transition-all duration-500 hover:shadow-xl`}
          style={{
            animation: "fadeInLeft 0.6s ease-out forwards",
            opacity: 0,
            transform: "translateX(-20px)",
          }}
        >
          <h3 className="text-lg font-medium mb-4">
            Service Booking Information
          </h3>
          <div className="h-64 w-full">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  activeIndex={activeIndex}
                  activeShape={renderActiveShape}
                  data={serviceTypeData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={80}
                  dataKey="value"
                  onMouseEnter={onPieEnter}
                >
                  {serviceTypeData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mt-3">
            {serviceTypeData.map((item) => (
              <div key={item.name} className="flex items-center">
                <div
                  className="w-3 h-3 rounded-full mr-1 sm:mr-2"
                  style={{ backgroundColor: item.color }}
                ></div>
                <span className="text-xs sm:text-sm text-gray-600">
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Monthly Bookings Chart */}
        <div
          className={`bg-white rounded-lg ${cardShadowClass} p-4 transform transition-all duration-500 hover:shadow-xl`}
          style={{
            animation: "fadeInRight 0.6s ease-out forwards",
            opacity: 0,
            transform: "translateX(20px)",
          }}
        >
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
            <h3 className="text-lg font-medium mb-1 sm:mb-0">
              Monthly Bookings
            </h3>
            <span className="text-xs sm:text-sm text-green-600">
              (+18%) than last year
            </span>
          </div>
          <div className="h-64 w-full">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={monthlyBookings}>
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Bar
                  dataKey="residentialBookings"
                  name="Residential"
                  fill="#2B4D7B"
                  isAnimationActive={true}
                  animationDuration={1000}
                  animationEasing="ease-in-out"
                />
                <Bar
                  dataKey="commercialBookings"
                  name="Commercial"
                  fill="#BBDEFB"
                  isAnimationActive={true}
                  animationDuration={1000}
                  animationEasing="ease-in-out"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="flex justify-center gap-3 sm:gap-4 mt-3">
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full mr-1 sm:mr-2 bg-blue-800"></div>
              <span className="text-xs sm:text-sm text-gray-600">
                Residential
              </span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full mr-1 sm:mr-2 bg-blue-200"></div>
              <span className="text-xs sm:text-sm text-gray-600">
                Commercial
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Today's Schedule Section - Mobile Responsive */}
      <div
        className={`bg-white rounded-lg ${cardShadowClass} p-4 mb-6 transform transition-all duration-500 hover:shadow-xl`}
        style={{
          animation: "fadeInUp 0.5s ease-out forwards",
          opacity: 0,
          transform: "translateY(20px)",
        }}
      >
        <h3 className="text-lg font-medium mb-4">Today's Schedule</h3>
        <div className="overflow-x-auto -mx-4 sm:mx-0">
          {" "}
          {/* Negative margin on mobile to allow scrolling within container */}
          <div className="min-w-full inline-block align-middle px-4 sm:px-0">
            {" "}
            {/* Container with minimum width */}
            <table className="min-w-full">
              <thead>
                <tr className="text-left bg-gray-50">
                  <th className="p-2 text-xs sm:text-sm rounded-tl-lg">Time</th>
                  <th className="p-2 text-xs sm:text-sm">Client</th>
            
                  <th className="p-2 text-xs sm:text-sm">Service</th>
                  <th className="p-2 text-xs sm:text-sm rounded-tr-lg">
                    Duration
                  </th>
                </tr>
              </thead>
              <tbody>
                {AllTodayBooking?.length > 0 ? (
                  AllTodayBooking.map((appointment, index) => (
                    <tr
                      key={appointment.order_id}
                      className={index % 2 === 0 ? "bg-gray-50" : ""}
                    >
                      <td className="p-2 border-t text-xs sm:text-sm">
                        <div className="flex items-center">
                          <Clock size={14} className="mr-1 text-blue-500" />
                          {new Date(
                            appointment.booking_date_time
                          ).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </td>
                      <td className="p-2 border-t text-xs sm:text-sm">
                        {appointment.client_name}
                      </td>
                     
                      <td className="p-2 border-t text-xs sm:text-sm">
                        {appointment.title}
                      </td>
                      <td className="p-2 border-t text-xs sm:text-sm">{`${appointment.order_duration} minutes`}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center p-4">
                      No bookings available for today.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  </div>
  );
};

export default CleaningStaffDashboard;

// import React, { useState, useEffect } from 'react';
// import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from 'recharts';
// import { PieChart, Pie, Sector } from 'recharts';
// import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
// import { LineChart, Line } from 'recharts';
// import { Sparkles, Users, Calendar, MessageSquare, ArrowUp, ArrowDown, Home, Clock } from 'lucide-react';

// const CleaningStaffDashboard = () => {
//   // Animation states
//   const [isLoaded, setIsLoaded] = useState(false);

//   useEffect(() => {
//     setIsLoaded(true);
//   }, []);

//   // Sample data for cleaning service
//   const statsData = [
//     { id: 1, title: 'Weekly cleanings', value: '127', change: '+3.2%', icon: Sparkles, color: 'bg-blue-100', textColor: 'text-blue-600', chartColor: '#1E88E5', positive: true },
//     { id: 2, title: 'New clients', value: '48', change: '+5.4%', icon: Users, color: 'bg-purple-100', textColor: 'text-purple-600', chartColor: '#9C27B0', positive: true },
//     { id: 3, title: 'Scheduled appointments', value: '152', change: '+2.8%', icon: Calendar, color: 'bg-amber-100', textColor: 'text-amber-600', chartColor: '#FFC107', positive: true },
//     { id: 4, title: 'Client reviews', value: '34', change: '-1.6%', icon: MessageSquare, color: 'bg-red-100', textColor: 'text-red-600', chartColor: '#EF5350', positive: false },
//   ];

//   const serviceTypeData = [
//     { name: 'Standard Clean', value: 45.8, color: '#1E88E5' },
//     { name: 'Deep Clean', value: 28.2, color: '#FFC107' },
//     { name: 'Move-in/out', value: 16.5, color: '#6A1B9A' },
//     { name: 'Office Clean', value: 9.5, color: '#FF7043' },
//   ];

//   const monthlyBookings = [
//     { month: 'Jan', residentialBookings: 40, commercialBookings: 25 },
//     { month: 'Feb', residentialBookings: 35, commercialBookings: 28 },
//     { month: 'Mar', residentialBookings: 42, commercialBookings: 30 },
//     { month: 'Apr', residentialBookings: 38, commercialBookings: 35 },
//     { month: 'May', residentialBookings: 45, commercialBookings: 40 },
//     { month: 'Jun', residentialBookings: 50, commercialBookings: 38 },
//     { month: 'Jul', residentialBookings: 55, commercialBookings: 42 },
//     { month: 'Aug', residentialBookings: 60, commercialBookings: 45 },
//     { month: 'Sep', residentialBookings: 52, commercialBookings: 40 },
//   ];

//   const clientSatisfactionData = [
//     { location: 'Downtown', value: 92, previous: 88 },
//     { location: 'Uptown', value: 88, previous: 85 },
//     { location: 'Westside', value: 95, previous: 90 },
//     { location: 'Eastside', value: 89, previous: 87 },
//     { location: 'Suburbs', value: 93, previous: 89 },
//   ];

//   const staffPerformanceData = [
//     { metric: 'Timeliness', teamAvg: 85, yourScore: 95, targetScore: 90, fullMark: 100 },
//     { metric: 'Quality', teamAvg: 80, yourScore: 90, targetScore: 85, fullMark: 100 },
//     { metric: 'Customer Service', teamAvg: 75, yourScore: 85, targetScore: 80, fullMark: 100 },
//     { metric: 'Efficiency', teamAvg: 70, yourScore: 80, targetScore: 75, fullMark: 100 },
//     { metric: 'Attention to Detail', teamAvg: 85, yourScore: 90, targetScore: 85, fullMark: 100 },
//     { metric: 'Equipment Care', teamAvg: 80, yourScore: 85, targetScore: 80, fullMark: 100 },
//   ];

//   // Generate mini chart data for stats cards
//   const generateMiniChartData = (positive) => {
//     const points = 10;
//     const result = [];
//     let prevValue = 50;

//     for (let i = 0; i < points; i++) {
//       const change = Math.random() * 15 - (positive ? 5 : 10);
//       const newValue = Math.max(10, Math.min(100, prevValue + change));
//       result.push({ value: newValue });
//       prevValue = newValue;
//     }

//     return result;
//   };

//   // Custom rendered activePieShape
//   const renderActiveShape = (props) => {
//     const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent } = props;

//     return (
//       <g>
//         <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill} className="text-sm font-medium">
//           {`${payload.name}`}
//         </text>
//         <text x={cx} y={cy + 20} textAnchor="middle" fill={fill} className="text-xs">
//           {`${(percent * 100).toFixed(1)}%`}
//         </text>
//         <Sector
//           cx={cx}
//           cy={cy}
//           innerRadius={innerRadius}
//           outerRadius={outerRadius + 5}
//           startAngle={startAngle}
//           endAngle={endAngle}
//           fill={fill}
//         />
//       </g>
//     );
//   };

//   const [activeIndex, setActiveIndex] = useState(0);
//   const onPieEnter = (_, index) => {
//     setActiveIndex(index);
//   };

//   // Today's appointments
//   const todayAppointments = [
//     { id: 1, time: '09:00 AM', client: 'John Smith', address: '123 Main St, Apt 4B', service: 'Standard Clean', duration: '2 hours' },
//     { id: 2, time: '11:30 AM', client: 'Emily Johnson', address: '456 Park Ave', service: 'Deep Clean', duration: '3 hours' },
//     { id: 3, time: '03:00 PM', client: 'Michael Brown', address: '789 Oak Dr', service: 'Move-out Clean', duration: '4 hours' },
//   ];

//   return (
//     <div className={`p-6 bg-gray-50 min-h-screen transition-opacity duration-700 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
//       <h1 className="text-2xl font-bold mb-6 transform transition-transform duration-500 translate-y-0 opacity-100">
//         Hi, Welcome back! 👋
//       </h1>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
//         {statsData.map((stat, index) => (
//           <div
//             key={stat.id}
//             className={`${stat.color} rounded-lg shadow-sm p-4 transform transition-all duration-500 hover:shadow-md hover:scale-105`}
//             style={{
//               animationDelay: `${index * 100}ms`,
//               animation: 'fadeInUp 0.5s ease-out forwards',
//               opacity: 0,
//               transform: 'translateY(20px)'
//             }}
//           >
//             <div className="flex justify-between items-start mb-2">
//               <div>
//                 <p className="text-sm text-gray-600">{stat.title}</p>
//                 <h3 className={`text-xl font-bold ${stat.textColor}`}>{stat.value}</h3>
//               </div>
//               <div className={`p-2 rounded-full ${stat.color}`}>
//                 <stat.icon size={20} className={stat.textColor} />
//               </div>
//             </div>
//             <div className="flex items-center justify-between">
//               <div className={`flex items-center text-sm ${stat.positive ? 'text-green-600' : 'text-red-600'}`}>
//                 {stat.positive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
//                 <span className="ml-1">{stat.change}</span>
//               </div>
//               <div className="w-20 h-12">
//                 <ResponsiveContainer width="100%" height="100%">
//                   <LineChart data={generateMiniChartData(stat.positive)}>
//                     <Line
//                       type="monotone"
//                       dataKey="value"
//                       stroke={stat.chartColor}
//                       strokeWidth={2}
//                       dot={false}
//                       isAnimationActive={true}
//                       animationDuration={1000}
//                       animationEasing="ease-in-out"
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Today's Schedule Section */}
//       <div
//         className="bg-white rounded-lg shadow-sm p-4 mb-6 transform transition-all duration-500 hover:shadow-md"
//         style={{
//           animation: 'fadeInUp 0.5s ease-out forwards',
//           opacity: 0,
//           transform: 'translateY(20px)'
//         }}
//       >
//         <h3 className="text-lg font-medium mb-4">Today's Schedule</h3>
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead>
//               <tr className="text-left bg-gray-50">
//                 <th className="p-2 rounded-tl-lg">Time</th>
//                 <th className="p-2">Client</th>
//                 <th className="p-2">Address</th>
//                 <th className="p-2">Service</th>
//                 <th className="p-2 rounded-tr-lg">Duration</th>
//               </tr>
//             </thead>
//             <tbody>
//               {todayAppointments.map((appointment, index) => (
//                 <tr key={appointment.id} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
//                   <td className="p-2 border-t">
//                     <div className="flex items-center">
//                       <Clock size={16} className="mr-2 text-blue-500" />
//                       {appointment.time}
//                     </div>
//                   </td>
//                   <td className="p-2 border-t">{appointment.client}</td>
//                   <td className="p-2 border-t">
//                     <div className="flex items-center">
//                       <Home size={16} className="mr-2 text-blue-500" />
//                       {appointment.address}
//                     </div>
//                   </td>
//                   <td className="p-2 border-t">{appointment.service}</td>
//                   <td className="p-2 border-t">{appointment.duration}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Charts Sections */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
//         {/* Service Type Distribution Chart */}
//         <div
//           className="bg-white rounded-lg shadow-sm p-4 transform transition-all duration-500 hover:shadow-md"
//           style={{
//             animation: 'fadeInLeft 0.6s ease-out forwards',
//             opacity: 0,
//             transform: 'translateX(-20px)'
//           }}
//         >
//           <h3 className="text-lg font-medium mb-4">Service Type Distribution</h3>
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   activeIndex={activeIndex}
//                   activeShape={renderActiveShape}
//                   data={serviceTypeData}
//                   cx="50%"
//                   cy="50%"
//                   innerRadius={60}
//                   outerRadius={80}
//                   dataKey="value"
//                   onMouseEnter={onPieEnter}
//                   isAnimationActive={true}
//                   animationDuration={1000}
//                   animationEasing="ease-in-out"
//                 >
//                   {serviceTypeData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={entry.color} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//           <div className="flex flex-wrap justify-center gap-4 mt-4">
//             {serviceTypeData.map((item) => (
//               <div key={item.name} className="flex items-center">
//                 <div className="w-3 h-3 rounded-full mr-2" style={{ backgroundColor: item.color }}></div>
//                 <span className="text-sm text-gray-600">{item.name}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Monthly Bookings Chart */}
//         <div
//           className="bg-white rounded-lg shadow p-4 transform transition-all duration-500 hover:shadow-md"
//           style={{
//             animation: 'fadeInRight 0.6s ease-out forwards',
//             opacity: 0,
//             transform: 'translateX(20px)'
//           }}
//         >
//           <div className="flex justify-between items-center mb-4">
//             <h3 className="text-lg font-medium">Monthly Bookings</h3>
//             <span className="text-sm text-green-600">(+18%) than last year</span>
//           </div>
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={monthlyBookings}>
//                 <XAxis dataKey="month" />
//                 <YAxis />
//                 <Tooltip />
//                 <Bar dataKey="residentialBookings" name="Residential" fill="#1E88E5" isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//                 <Bar dataKey="commercialBookings" name="Commercial" fill="#BBDEFB" isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//           <div className="flex justify-center gap-4 mt-4">
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full mr-2 bg-blue-500"></div>
//               <span className="text-sm text-gray-600">Residential</span>
//             </div>
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full mr-2 bg-blue-200"></div>
//               <span className="text-sm text-gray-600">Commercial</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Charts */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Client Satisfaction Rates */}
//         <div
//           className="bg-white rounded-lg shadow-sm p-4 transform transition-all duration-500 hover:shadow-md"
//           style={{
//             animation: 'fadeInUp 0.7s ease-out forwards',
//             opacity: 0,
//             transform: 'translateY(20px)'
//           }}
//         >
//           <div className="flex justify-between items-center mb-4">
//             <h3 className="text-lg font-medium">Client Satisfaction by Area</h3>
//             <span className="text-sm text-green-600">(+4.2%) than last quarter</span>
//           </div>
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart
//                 layout="vertical"
//                 data={clientSatisfactionData}
//                 margin={{ top: 10, right: 30, left: 60, bottom: 10 }}
//               >
//                 <XAxis type="number" domain={[0, 100]} />
//                 <YAxis dataKey="location" type="category" />
//                 <Tooltip />
//                 <Bar dataKey="previous" name="Previous Quarter" fill="#E0E0E0" isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//                 <Bar dataKey="value" name="Current Quarter" fill="#1E88E5" isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Staff Performance */}
//         <div
//           className="bg-white rounded-lg shadow-sm p-4 transform transition-all duration-500 hover:shadow-md"
//           style={{
//             animation: 'fadeInUp 0.8s ease-out forwards',
//             opacity: 0,
//             transform: 'translateY(20px)'
//           }}
//         >
//           <h3 className="text-lg font-medium mb-4">Your Performance Metrics</h3>
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <RadarChart cx="50%" cy="50%" outerRadius="80%" data={staffPerformanceData}>
//                 <PolarGrid />
//                 <PolarAngleAxis dataKey="metric" />
//                 <PolarRadiusAxis angle={30} domain={[0, 100]} />
//                 <Radar name="Team Average" dataKey="teamAvg" stroke="#4DD0E1" fill="#4DD0E1" fillOpacity={0.6} isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//                 <Radar name="Your Score" dataKey="yourScore" stroke="#1E88E5" fill="#1E88E5" fillOpacity={0.6} isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//                 <Radar name="Target" dataKey="targetScore" stroke="#FFC107" fill="#FFC107" fillOpacity={0.6} isAnimationActive={true} animationDuration={1000} animationEasing="ease-in-out" />
//                 <Tooltip />
//               </RadarChart>
//             </ResponsiveContainer>
//           </div>
//           <div className="flex justify-center gap-4 mt-4">
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full mr-2 bg-cyan-400"></div>
//               <span className="text-sm text-gray-600">Team Average</span>
//             </div>
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full mr-2 bg-blue-500"></div>
//               <span className="text-sm text-gray-600">Your Score</span>
//             </div>
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full mr-2 bg-amber-400"></div>
//               <span className="text-sm text-gray-600">Target</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* CSS for animations */}
//       <style jsx>{`
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes fadeInLeft {
//           from {
//             opacity: 0;
//             transform: translateX(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         @keyframes fadeInRight {
//           from {
//             opacity: 0;
//             transform: translateX(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CleaningStaffDashboard;
